import { fonts, palette } from '../../styles/variables'

export const INITIAL_CARD_STYLE = {
  width: 30,
  height: 40,
  background: palette.orange70,
  gap: 20,
}
export const INITIAL_TEXT_STYLE = {
  fontFamily: 'Courier, Droid Sans Mono, monospace',
  fontSize: '20px',
  fontWeight: 700,
  color: palette.white,
}
export const INITIAL_DIVIDER_STYLE = {
  fontSize: '20px',
  fontFamily: fonts.primaryBold,
  color: palette.white,
}

export const INITIAL_LABEL_STYLE = {
  color: palette.white,
}
